import React, { useEffect, useState } from "react";
import Frame from "react-frame-component";
import { useSelector } from "react-redux";
import { openLink } from "../utils/helpers";
import SizeSelector from "../utils/size-selector";
import Cta from "./cta";
import "./trade.css";

const selectors = [
  { icon: "desktop", title: "Desktop 918 x 110" },
  { icon: "laptop", title: "Laptop 724 x 110" },
  { icon: "tablet", title: "Tablet 532 x 110" },
  { icon: "mobile-mpu", title: "Mobile 375 x 258" },
  { icon: "mobile-slim", title: "Mobile 375 x 110" },
];

const StageBanner = ({ banner, retailer }) => {
  const selectorClass = useSelector((state) => state.divClass || "desktop");

  const [hasLogo, setHasLogo] = useState("no");
  const [ccpSize, setCcpSize] = useState("value-tile-clubcard");

  useEffect(() => {
    if (banner.logo) {
      if (banner.logo.path) setHasLogo("yes");
    }
  }, [banner]);

  useEffect(() => {
    if (banner.clubcardPrice) {
      setCcpSize(
        !banner.valueTileBottom && !banner.valueTileTop
          ? "value-tile-clubcard ccp-only"
          : "value-tile-clubcard"
      );
    }
  }, [banner]);

  const chevronCss = (chevron) => {
    chevron = chevron.trim();
    return `url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2058%2058%22%3E%3Cpath%20fill%3D%22%23${chevron}%22%20d%3D%22M19.917%2015.84a1.352%201.352%200%200%200%200%201.92L31.26%2029.005%2019.917%2040.248a1.356%201.356%200%200%200%200%201.924l1.457%201.44c.534.532%201.41.532%201.943%200l13.785-13.646a1.356%201.356%200%200%200%200-1.924L23.317%2014.396a1.39%201.39%200%200%200-1.943%200l-1.457%201.444z%22%2F%3E%3C%2Fsvg%3E)`;
  };

  const mainClasses = (hideClass) => {
    const primaryOnly =
      "banner__primary_only-" +
      (banner.secondaryPackshot
        ? banner.secondaryPackshot.path
          ? "no"
          : "yes"
        : "yes");
    const showPanel = `banner_hasPanel-${banner.includePanel}`;
    const hidePanel =
      "hide-panel--" + (hideClass.indexOf("mobile-slim") === -1 ? "no" : "yes");
    const splitpanel = "split-panel-" + (banner.fiftyfifty ? "yes" : "no");
    const valuetile = "value-tile-" + (banner.valueTile ? "yes" : "no");
    const newValueTile =
      "value-tile-lozenge-" + (banner.newValueTile ? "yes" : "no");
    return `slim-trade-banner slim-trade-banner__high ${showPanel} ${primaryOnly} ${hidePanel} ${splitpanel} ${valuetile} ${retailer} ${newValueTile}`;
  };

  const allThree = () => {
    const terms = banner.terms || banner.drinkaware;
    const subhead = banner.subhead;
    const allthree = terms && subhead ? " all-three" : "";
    const pos = banner.backgroundPosition
      ? `bg-${banner.backgroundPosition}`
      : "bg-right";
    return `stamp--a${allthree} ${pos}`;
  };

  const ccpMarginFix = (topFont, pos) => {
    let spanSize = parseInt(topFont.slice(0, topFont.indexOf("px")), 10);
    if (pos === "one") return spanSize > 39 ? "0" : "4px";
    if (pos === "two") return spanSize > 49 ? "-4px" : "0";
    if (pos === "three") return spanSize > 49 ? "-2px" : "0";
  };

  const vtStyle = {
    backgroundColor: banner.valueTileBackground,
    color: banner.valueTileColor,
  };

  const vtTileTop = {
    fontSize: banner.valueTileTopFont,
    textDecoration: banner.strikethrough ? "line-through" : "none",
    marginBottom: banner.clubcardPrice
      ? ccpMarginFix(banner.valueTileTopFont, "one")
      : "4px",
    marginTop: banner.clubcardPrice
      ? ccpMarginFix(banner.valueTileTopFont, "two")
      : "0",
  };

  const vtTileBottom = {
    fontSize: banner.valueTileBottomFont,
    marginTop: banner.clubcardPrice
      ? ccpMarginFix(banner.valueTileTopFont, "three")
      : "0",
  };

  const asteriskStyle = {
    display: banner.includeAsterisk ? "inline" : "none",
    fontSize: banner.asteriskSize,
  };

  const regularPriceStyle = {
    fontSize: banner.regularPriceFontSize,
  };

  const noWidow = (t) => {
    let text = t;
    const i = text.lastIndexOf(" ");
    if (i !== -1) {
      text = text.replace(/\s(?=[^\s]*$)/g, "\u00A0");
    }
    const j = text.indexOf("&#8209;");
    if (j !== -1) {
      text = text.replace(/&#8209;/g, "\u2011");
    }
    return text;
  };

  const url = encodeURIComponent(banner.bannerURL);

  return (
    <SizeSelector selectors={selectors}>
      <Frame
        initialContent={`<!DOCTYPE html><html><head><link
          href="${process.env.PUBLIC_URL}/static/css/trade.css?v=18"
          rel="stylesheet"
        /></head><body><div id="bannerFrame"></div></body></html>`}
        mountTarget="#bannerFrame"
        className={`regularprice-${banner.includeRegularPrice ? "yes" : "no"}`}
      >
        <div className={mainClasses(selectorClass)}>
          <div
            style={{ backgroundColor: `${banner.bgColor}` }}
            className={`slim-banner--wrap tescosearch-${
              banner.tescoSearch ? "yes" : "no"
            } regularprice-${banner.includeRegularPrice ? "yes" : "no"}`}
          >
            <a
              className={allThree()}
              href={`${url}`}
              id="stamp-a"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => openLink(e, url)}
            >
              <span
                className={`img--container img-${
                  banner.orientation
                } include-padding-${banner.includePadding ? "yes" : "no"}`}
                style={
                  banner.background && {
                    backgroundImage: `url("${banner.background.path}")`,
                  }
                }
              >
                {banner.primaryPackshot && banner.primaryPackshot.path && (
                  <img
                    src={banner.primaryPackshot.path}
                    className="trade--product trade--product_1"
                    alt={banner.primaryAlt}
                  />
                )}
                {banner.secondaryPackshot && (
                  <img
                    src={banner.secondaryPackshot.path}
                    className="trade--product trade--product_2"
                    alt={banner.secondaryAlt}
                  />
                )}
                <span
                  className={`eventPing-widget vt-white-${
                    banner.vtWhite ? "yes" : "no"
                  } clubcardprice-${
                    banner.clubcardPrice ? "yes" : "no"
                  } threed-ccp-tile-${
                    banner.threedClubcardTile ? "yes" : "no"
                  }`}
                  style={vtStyle}
                >
                  <span
                    className={`value-tile ccp-tile-${
                      banner.clubcardPrice ? "yes" : "no"
                    }`}
                    style={{ display: banner.valueTile ? "block" : "none" }}
                  >
                    <span className="value-tile-lozenge-top">
                      <span className="value-tile-top" style={vtTileTop}>
                        {banner.valueTileTop}
                      </span>
                      <span
                        className={`value-tile-bottom${
                          banner.percentSign === "%" ? " vt-sub" : ""
                        }${banner.decimalPlace ? " vt-sup" : ""}`}
                        style={vtTileBottom}
                      >
                        <span>
                          {banner.valueTileBottom}
                          <sup>{banner.decimalPlace}</sup>
                          <sub>{banner.percentSign}</sub>
                        </span>
                        <span
                          className={
                            banner.includeAsterisk
                              ? `asterisk-yes`
                              : `asterisk-no`
                          }
                          style={asteriskStyle}
                        >
                          *
                        </span>
                      </span>
                      <span className="currency-symbol">
                        {banner.vtCurrency}
                      </span>
                    </span>
                    <span className="value-tile-lozenge-divider"></span>
                    <span className="value-tile-lozenge-bottom">
                      <span className={ccpSize}>
                        {banner.ccpText ? banner.ccpText : "Clubcard Price"}
                      </span>
                    </span>
                  </span>
                  <span className="regular-price">
                    <span className="regular-price-text">
                      {banner.regularPrice}
                    </span>
                    <span
                      className="regular-price-price"
                      style={regularPriceStyle}
                    >
                      {banner.regularPricePrice}
                    </span>
                  </span>
                </span>
              </span>
              <span
                className={`panel--container panel-${hasLogo}logo panel-${banner.orientation}`}
                style={
                  banner.background && {
                    backgroundColor: `${banner.panelColor}`,
                    backgroundImage: `url("${banner.background.path}")`,
                  }
                }
              >
                {banner.logo && (
                  <span
                    className="panel--img"
                    id="panel-img"
                    style={{ display: !banner.logo.path && "none" }}
                  >
                    <img
                      src={banner.logo.path}
                      className="banner--brand-img"
                      alt={banner.logoAlt}
                    />
                  </span>
                )}
                <span
                  className="panel--inner"
                  style={{ color: `${banner.fontColor}` }}
                >
                  <span className="caption--title">
                    {banner.headline && noWidow(banner.headline)}
                  </span>
                  <span className="caption--sub_headline">
                    {banner.subhead && noWidow(banner.subhead)}
                  </span>
                  <p className="drinkaware">
                    <span>{banner.terms}</span>
                    <span
                      className="da-logo"
                      style={{
                        display: banner.drinkaware ? "block" : "none",
                      }}
                    >
                      {retailer === "tesco_ie" ? (
                        <span>Responsible Retailing of Alcohol in Ireland</span>
                      ) : (
                        <>
                          be <span>drinkaware</span>.co.uk
                        </>
                      )}
                    </span>
                  </p>
                </span>
                <span className={banner.invertCta ? `invert-yes` : `invert-no`}>
                  <span className="cta cta1">
                    <Cta
                      className="cta_inner"
                      bgColor={banner.ctaColor}
                      bgImage={
                        banner.chevronColor &&
                        chevronCss(banner.chevronColor.slice(1))
                      }
                    />
                  </span>
                  <span className="cta cta2">
                    <Cta
                      className="cta_inner"
                      bgColor={banner.fontColor}
                      bgImage={
                        banner.panelColor &&
                        chevronCss(banner.panelColor.slice(1))
                      }
                    />
                  </span>
                  <span className="cta cta3">
                    <Cta
                      className="cta_inner"
                      bgColor={`#fff`}
                      bgImage={
                        banner.panelColor &&
                        chevronCss(banner.panelColor.slice(1))
                      }
                    />
                  </span>
                </span>
              </span>
            </a>
          </div>
        </div>
      </Frame>
    </SizeSelector>
  );
};

export default StageBanner;
